import { useFormik, FormikProvider, Form, Field, ErrorMessage, FieldArray } from "formik";
import { FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import { useEffect, useState } from "react";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import * as Yup from "yup";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly } from "../CommonUtils/CommonValidations";
import { aadhaarValidation } from "../CommonYupValidations";
import Select from "react-select";

export default function StaffDetails({ goNext, paymentDone }) {
    console.log("paymentDone", paymentDone)
    const Clg = sessionStorage?.getItem("LOGIN");

    const validationSchema = Yup.object({

        staffDetails: Yup.array().of(
            Yup.object({
                staffName: Yup.string().required(ERROR_MSG).nullable(),
                staffDesignation: Yup.string().required(ERROR_MSG).nullable(),

                staffMobile: Yup.string()
                    .matches(/^[6-9]\d{9}$/, "Enter valid 10-digit mobile number")
                    .required("Mobile number is required"),

                staffQualificationlist: Yup.array()
                    .min(1, "Select at least one qualification")
                    .required("Qualification is required"),

                staffAadhar: aadhaarValidation,
                salary: Clg !== "degree"
                    ? Yup.string().required(ERROR_MSG)
                    : Yup.string().nullable(),
                doj: Yup.string().required(ERROR_MSG).nullable(),
                remarks: Yup.string().required(ERROR_MSG).nullable(),
                courseId: Yup.string().required(ERROR_MSG).nullable(),

            })
        )
    });
    const InstitutionFormik = useFormik({
        initialValues: {
            staffDetails: [
                {
                    staffName: "",
                    staffDesignation: "",
                    staffQualificationlist: [],
                    staffMobile: "",
                    staffAadhar: "",
                    staffYearOfAppointment: "",
                    salary: "",
                    doj: "",
                    remarks: "",
                    courseId: "",
                },
            ],

        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (val) => {
            const updatedValues = {
                ...val,
                staffDetails: val.staffDetails.map(staff => ({
                    ...staff,

                    // ✅ convert UI multi-select to API format
                    staffQualificationlist: (staff.staffQualificationlist || []).map(q => String(q)),

                }))
            };

            updatedValues.staffDetails = updatedValues.staffDetails.map(({ staffQualificationlist, ...rest }) => rest);

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `saveStaffDetails`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetStaffdtls();
                            goNext();

                        }
                        else if (res?.data?.scode === '02') {
                            Swal.fire(res?.data?.sdesc, '', 'error').then((res) => {
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        },
        validateOnBlur: true,
        validateOnChange: true,
    });

    console.log("InstitutionFormik", InstitutionFormik?.values?.staffDetails)
    const [designation, setDesignation] = useState([]);
    function GetDesignations() {
        CommonAxiosGet(`${config.url.FAC_URL}getDesignation`).then((res) => {
            setDesignation(res?.data?.scode === "01" ? res?.data?.data || [] : []);
        });
    }


    const [qualification, setQualification] = useState([]);
    function GetQualification() {
        CommonAxiosGet(`${config.url.FAC_URL}getQualifications`).then((res) => {
            setQualification(res?.data?.scode === "01" ? res?.data?.Qualifications || [] : []);
        });
    }

    const options = qualification.map((d) => ({
        value: d.course_cat_id,
        label: d.course_cat_name,
    }));

    function GetStaffdtls() {

        CommonAxiosGet(`${config.url.FAC_URL}getStaffDetailsList`).then((res) => {

            if (res?.data?.scode === "01") {

                const details = res?.data?.details || [];

                if (details.length > 0) {

                    const mapped = details.map(item => ({
                        staffName: item?.staff_name || "",
                        courseId: item?.course_id || '',
                        staffDesignation: Number(item?.staff_designation) || "",
                        staffQualificationlist: item?.staff_qualification
                            ? item.staff_qualification.split(",").map(Number)
                            : [],
                        // staffType: item?.staff_type || "",
                        staffMobile: item?.staff_mobile || "",
                        staffAadhar: item?.staff_aadhar || "",
                        staffYearOfAppointment: item?.yr_of_joining || '',

                        doj: item?.doj || '',
                        ...(Clg !== "degree" && { salary: item?.salary || '' }),
                        //   salary: item?.salary || '',
                        remarks: item?.remarks || ""
                    }));

                    InstitutionFormik.setFieldValue("staffDetails", mapped);

                } else {

                    // ✅ If API returns empty list
                    InstitutionFormik.setFieldValue("staffDetails", [
                        {
                            staffName: "",
                            staffDesignation: "",
                            staffQualificationlist: [],
                            // staffType: "",
                            staffMobile: "",
                            staffAadhar: "",
                            staffYearOfAppointment: "",
                            salary: "",
                            doj: "",
                            remarks: ""
                        }
                    ]);

                }

            } else {

                // ✅ If API fails
                InstitutionFormik.setFieldValue("staffDetails", [
                    {
                        staffName: "",
                        staffDesignation: "",
                        staffQualification: "",
                        // staffType: "",
                        staffMobile: "",
                        staffAadhar: "",
                        staffYearOfAppointment: "",
                        salary: "",
                        doj: "",
                        remarks: ""
                    }
                ]);

            }

        });

    }

    const [clgcrs, setClgcrs] = useState([]);
    function GetCollegeCourses() {
        let url = config.url.FAC_URL + `getCollegeCourses`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setClgcrs(res?.data?.data);
            }
            else {
                setClgcrs([]);
            }
        })
    }


    const [degreecourses, setDegreecourses] = useState([]);
    function Getdegreecourses() {
        let url = config.url.FAC_URL + `getdepartments`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setDegreecourses(res?.data?.getdepartments);
            }
            else {
                setDegreecourses([]);
            }
        })
    }



    useEffect(() => {
        GetStaffdtls();
        Getdegreecourses();
        GetCollegeCourses();
        GetDesignations();
        GetQualification();
    }, [])

    const Qualoptions = [
        { value: "", label: "---select--" },   // ✅ manual option
        ...(qualification?.map((item) => ({
            value: item.course_cat_id,
            label: item.course_cat_name,
        })) || [])
    ];


    return (
        <>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">

                    <FormikProvider value={InstitutionFormik}>
                        <Form
                            className="form_adjust"
                            onSubmit={InstitutionFormik?.handleSubmit}
                            onChange={InstitutionFormik?.handleChange}
                        >
                            {/* ================= PERSONAL DETAILS ================= */}
                            <h5 className="mb-3 innerheader-new"><span>Staff Details</span></h5>


                            <bie.Card.Body>
                                <bie.Alert variant="info" className="small">
                                    <strong>Note:</strong> Intake (S) is auto-summed. Faculty count (F) is auto-counted. Required SFR: 25 to 30.
                                </bie.Alert>


                                <div className="table-responsive">
                                    <FieldArray name="staffDetails">
                                        {({ push, remove }) => (
                                            <>

                                                <div className="table-responsive">
                                                    <FieldArray name="staffDetails">
                                                        {({ push, remove }) => (

                                                            <table className="table table-bordered mt-2 ">

                                                                <thead className="table-primary">
                                                                    <tr>
                                                                        <th style={{ width: "60px" }}>S.No</th>
                                                                        <th>Name of Faculty</th>
                                                                        <th>Staff Designation</th>
                                                                        <th>Staff Qualification</th>
                                                                        {/* <th>Regular / Contract</th> */}

                                                                        {/* <th>{Clg !== "degree" && "Salary"}</th> */}
                                                                        {Clg !== "degree" &&
                                                                            <th> Salary</th>}

                                                                        <th>Contact No.</th>
                                                                        <th>Aadhaar No</th>
                                                                        <th>Date of Joining </th>
                                                                        <th>Year of Appt.</th>
                                                                        <th>{Clg === "degree" ? "Department" : "Course"}</th>

                                                                        <th>Remarks</th>
                                                                        <th style={{ width: "70px" }}>Action</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>

                                                                    {InstitutionFormik?.values?.staffDetails?.map((item, index) => (
                                                                        <tr key={index}>

                                                                            <td className="text-center fw-bold">
                                                                                {index + 1}
                                                                            </td>


                                                                            <td>
                                                                                <Field
                                                                                    type="text"
                                                                                    name={`staffDetails[${index}].staffName`}
                                                                                    className="form-control form-control-sm"
                                                                                    onKeyPress={allowAlphabetAndSpacesOnly}
                                                                                    maxLength={25}

                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].staffName`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>

                                                                            <td>
                                                                                <Field
                                                                                    as="select"
                                                                                    name={`staffDetails[${index}].staffDesignation`}
                                                                                    className="select-input"
                                                                                >
                                                                                    <option value="">--Select--</option>
                                                                                    {designation?.map((d) => (
                                                                                        <option key={d.designation_id} value={d.designation_id}>
                                                                                            {d.designation_name}
                                                                                        </option>
                                                                                    ))}
                                                                                </Field>
                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].staffDesignation`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>
                                                                            <td style={{ minWidth: "250px" }}>
                                                                                <Select
                                                                                    isMulti
                                                                                    options={Qualoptions}
                                                                                    placeholder="Select qualifications..."

                                                                                    value={Qualoptions.filter((opt) =>
                                                                                        InstitutionFormik.values.staffDetails?.[index]?.staffQualificationlist?.includes(opt.value)
                                                                                    )}

                                                                                    onChange={(selected) => {
                                                                                        const values = selected ? selected.map((item) => item.value) : [];

                                                                                        InstitutionFormik.setFieldValue(
                                                                                            `staffDetails[${index}].staffQualificationlist`,
                                                                                            values
                                                                                        );
                                                                                    }}

                                                                                    styles={{
                                                                                        menu: (provided) => ({
                                                                                            ...provided,
                                                                                            zIndex: 9999,
                                                                                        }),
                                                                                        menuList: (provided) => ({
                                                                                            ...provided,
                                                                                            maxHeight: "150px",
                                                                                            overflowY: "auto",
                                                                                        }),
                                                                                    }}

                                                                                    menuPortalTarget={document.body}
                                                                                />

                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].staffQualificationlist`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>


                                                                            {/* <td >
                                                                                <Field
                                                                                    as="select"
                                                                                    name={`staffDetails[${index}].staffType`}
                                                                                    className="select-input"
                                                                                >
                                                                                    <option value="">--Select--</option>
                                                                                    <option value="1">Full Time</option>
                                                                                    <option value="2">Contract</option> --remove
                                                                                </Field>
                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].staffType`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td> */}
                                                                            {Clg !== "degree" && (
                                                                                <td>
                                                                                    <Field
                                                                                        type="text"
                                                                                        maxLength={8}
                                                                                        onKeyPress={allowNumbersOnly}
                                                                                        name={`staffDetails[${index}].salary`}
                                                                                        className="form-control"
                                                                                    />
                                                                                    <ErrorMessage
                                                                                        name={`staffDetails[${index}].salary`}
                                                                                        component="small"
                                                                                        className="text-danger"
                                                                                    />
                                                                                </td>
                                                                            )}

                                                                            <td>
                                                                                <Field
                                                                                    type="text"
                                                                                    name={`staffDetails[${index}].staffMobile`}
                                                                                    onKeyPress={allowNumbersOnly}

                                                                                    className="form-control form-control-sm"
                                                                                    maxLength={10}
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].staffMobile`}

                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>

                                                                            <td>
                                                                                <Field
                                                                                    type="text"
                                                                                    name={`staffDetails[${index}].staffAadhar`}
                                                                                    onKeyPress={allowNumbersOnly}

                                                                                    className="form-control form-control-sm"
                                                                                    maxLength={12}
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].staffAadhar`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>



                                                                            <td>
                                                                                <Field
                                                                                    type="date"
                                                                                    name={`staffDetails[${index}].doj`}

                                                                                    className="form-control form-control-sm"
                                                                                    max={new Date().toISOString().split("T")[0]}


                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].doj`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>
                                                                            <td>


                                                                                <Field type="text" name={`staffDetails[${index}].staffYearOfAppointment`} className="form-control" disabled />
                                                                                {/* <option value="">Select Year</option>

                                                                                    {[...Array(new Date().getFullYear() - 1947 + 1).keys()]
                                                                                        .map((i) => {
                                                                                            const year = 1947 + i;
                                                                                            return (
                                                                                                <option key={year} value={year}>
                                                                                                    {year}
                                                                                                </option>
                                                                                            );
                                                                                        })} */}
                                                                                {/* <ErrorMessage
                                                                                    name={`staffDetails[${index}].staffYearOfAppointment`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                /> */}
                                                                            </td>
                                                                            <td>
                                                                                <Field as="select"
                                                                                    name={`staffDetails[${index}].courseId`}
                                                                                    className="select-input">
                                                                                    <option value="">---select---</option>
                                                                                    {/* {clgcrs && clgcrs?.map((pp, i) => (
                                                                                    <option value={pp?.course_id} key={i}>{pp?.course_name}</option>
                                                                                ))} */}

                                                                                    {Clg === "degree"
                                                                                        ? degreecourses?.map((course, i) => (
                                                                                            <option value={course.dept_id} key={i}>
                                                                                                {course.dept_name}
                                                                                            </option>
                                                                                        ))
                                                                                        : clgcrs?.map((course, i) => (
                                                                                            <option value={course.course_id} key={i}>
                                                                                                {course.course_name}
                                                                                            </option>
                                                                                        ))
                                                                                    }
                                                                                </Field>
                                                                                {/* <ErrorMessage
                                                                                    name={`staffDetails[${index}].courseId`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                /> */}
                                                                                {InstitutionFormik.errors?.staffDetails?.[index]?.courseId &&
                                                                                    InstitutionFormik.touched?.staffDetails?.[index]?.courseId && (
                                                                                        <small className="text-danger">
                                                                                            {InstitutionFormik.errors.staffDetails[index].courseId}
                                                                                        </small>
                                                                                    )}

                                                                            </td>

                                                                            <td>
                                                                                <Field
                                                                                    as="textarea"
                                                                                    name={`staffDetails[${index}].remarks`}
                                                                                    className="form-control form-control-sm"
                                                                                    onKeyPress={allowAlphabetAndSpacesOnly}
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`staffDetails[${index}].remarks`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>

                                                                            <td className="text-center">

                                                                                {InstitutionFormik?.values?.staffDetails?.length > 1 && (

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link text-danger p-0"
                                                                                        onClick={() => remove(index)}
                                                                                    >
                                                                                        <FaTrashAlt size={16} />
                                                                                    </button>

                                                                                )}

                                                                            </td>

                                                                        </tr>
                                                                    ))}

                                                                </tbody>

                                                                {/* TABLE FOOTER */}
                                                                <tfoot className="faculty-table-footer">

                                                                    <tr>
                                                                        <td colSpan={Clg === "degree" ? 12 : 13} className="text-end">
                                                                            <bie.Button
                                                                                variant="success"
                                                                                size="sm"
                                                                                onClick={() => push({
                                                                                    staffName: "",
                                                                                    staffDesignation: "",
                                                                                    staffQualificationlist: [],
                                                                                    // staffType: "",
                                                                                    staffMobile: "",
                                                                                    doj: "",
                                                                                    staffYearOfAppointment: "",
                                                                                    remarks: "",
                                                                                    staffAadhar: "",
                                                                                    courseId: "",
                                                                                    ...(Clg !== "degree" && { salary: "" })

                                                                                })}
                                                                            >
                                                                                <FaPlusCircle className="me-2" />
                                                                                Add Faculty
                                                                            </bie.Button>

                                                                        </td>
                                                                    </tr>

                                                                </tfoot>

                                                            </table>

                                                        )}
                                                    </FieldArray>
                                                </div>
                                            </>
                                        )}
                                    </FieldArray>
                                </div>



                                {/* <div className="d-flex justify-content-end mt-4">
                                    <button className="btn btn-primary" type="submit">   Submit</button>
                                </div> */}

                                <div className="d-flex justify-content-end mt-4">
                                    {paymentDone ? (
                                        <div style={{ color: "green", fontWeight: "bold" }}>
                                            ✅ Already submitted
                                        </div>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="btn btn-success btn-sm"
                                        >
                                            Submit
                                        </button>
                                    )}
                                </div>


                            </bie.Card.Body>


                        </Form >
                    </FormikProvider >



                </div >
            </div >
        </>
    )
}
